import React, { useEffect } from "react";

const Checkout = () => {
  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("rcs_cart")) || [];

    const sendToStripe = async () => {
      try {
        const response = await fetch("https://rcsbackend.onrender.com/api/checkout/create-checkout-session", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ cartItems: cart }),
        });
        

        const data = await response.json();

        if (data.url) {
          window.location.href = data.url; // ⏩ Redirect to Stripe
        } else {
          alert("Something went wrong with Stripe");
        }
      } catch (err) {
        console.error("Checkout error:", err);
      }
    };

    sendToStripe();
  }, []);

  return (
    <div className="checkout-page">
      <h2>Redirecting to secure Stripe checkout...</h2>
    </div>
  );
};

export default Checkout;
